/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum System {
  Primary = '#419BF9',
  Dark = '#0D7FFF',
  Light = '#C1E0FF',
  Lightest = '#E2F0FF',
  Success = '#35ED98',
}

export enum Neutrals {
  Dark = '#333333',
  Text = '#6F747C',
  Gray = '#8c8c8c',
  Border = '#D1D3D6',
  Light = '#F2F4F8',
  Paper = '#FFFFFF',
  Surface = '#FFFFFF',
}

export enum NeutralsFixed {
  Dark = '#131821',
  Text = '#6F747C',
  Border = '#D1D3D6',
  Light = '#F2F4F8',
  Gray = '#8c8c8c',
  Paper = '#FFFFFF',
  Surface = '#FFFFFF',
}

export enum TextContrast {
  Primary = NeutralsFixed.Paper,
  Secondary = Neutrals.Dark,
}

const INFO_LIGHT_COLOR = '#E0E7FF';

export enum Feedback {
  Alert = '#FF6565',
  AlertLight = '#FFE0E0',
  Success = '#1ECAA1',
  SuccessLight = '#DCFFF0',
  Warning = '#FFCB5C',
  WarningLight = '#FFECC2',
  Info = '#0038FF',
  InfoLight = INFO_LIGHT_COLOR,
  InfoSpecial = INFO_LIGHT_COLOR,
}

export enum Brand {
  Primary = '#6659E3',
  Dark = '#4636DD',
  Darkest = '#2B373F',
  Light = '#DAD7F8',
  Lightest = '#F0EEFC',
  SpecialLight = '#56CF7D',
  Special = '#56CF7D',
  SpecialDark = '#47AB67',
}

export enum Overlay {
  Light = 'rgba(19, 24, 33, 0.16)',
  Default = 'rgba(0, 0, 0, 0.45)',
  Hover = 'rgba(19, 24, 33, 0.85)',
}

export enum OverlayFixed {
  Light = 'rgba(19, 24, 33, 0.16)',
  Default = 'rgba(0, 0, 0, 0.45)',
  Hover = 'rgba(19, 24, 33, 0.85)',
}

export enum Pro {
  Badge = '#F4C304',
}
